module.exports = __webpack_public_path__ + "static/media/twitter.8079806b.png";